import { SearchComboBox } from '@components/app/panels/right-panel/combo-box'
import type { PortraitFilterDropdown } from '../types/portrait-filter-dropdown'

type PortraitsFilterComboProps = {
  filter: PortraitFilterDropdown
  placeholder: string
  /** The field's accessible name, read with the shown value ("Custom Deep Blue Chess Team"). */
  ariaLabel: string
  /** What the options are, for the loading and error text ("grades", "custom groups"). */
  noun: string
}

/** One single-select dropdown of the Filters section (Grade, Homeroom, Custom): the shared
 *  searchable combobox fed from a `PortraitFilterDropdown`, saying so while its options load or
 *  fail, as the other trays' comboboxes do. */
export function PortraitsFilterCombo({
  filter,
  placeholder,
  ariaLabel,
  noun,
}: PortraitsFilterComboProps) {
  return (
    <SearchComboBox
      placeholder={placeholder}
      ariaLabel={ariaLabel}
      options={filter.options}
      isLoading={filter.isLoading}
      isError={filter.isError}
      loadingMessage={`Loading ${noun}…`}
      errorMessage={filter.errorMessage ?? `Failed to load ${noun}`}
      onRetry={filter.onRetry}
      value={filter.value}
      onValueChange={filter.onChange}
      onOpenChange={filter.onOpenChange}
    />
  )
}
